import React from 'react';
import { observer } from 'mobx-react-lite';
import { Context } from '../../../../index';
import { PRODUCT_TITLES } from '../firmwareProducts';

interface FirmwareSelectorProps {
  onStopPolling: () => void;
}

const FirmwareSelector: React.FC<FirmwareSelectorProps> = observer(({ onStopPolling }) => {
  const { adminStore } = React.useContext(Context);
  const module = adminStore.adminModule;
  // `ОБН.4`: тип изделия рядом с номером — по нему видно, почему блоков два
  // или три. Пустой тип — пометка, что он не задан.
  const deviceType = String(module?.device_type || '').toLowerCase();
  const deviceTitle = PRODUCT_TITLES[deviceType] || (deviceType ? deviceType : 'тип изделия не задан');

  return (
    <div style={{ display: "flex" }}>
      <h2>
        Обновление прошивки модуля{" "}
        <div style={{ color: "red" }}>
          {module?.charge_id}
          <span className="FW-module-device"> — {deviceTitle}</span>
        </div>
      </h2>
      <div style={{ marginBottom: "20px" }}>
        <label htmlFor="module-selector"></label>
        <select
          id="module-selector"
          value={module?.charge_id || ""}
          onChange={(e) => {
            const selectedModule = adminStore.modules.find(
              (m) => m.charge_id === e.target.value,
            );
            if (selectedModule) {
              adminStore.setAdminModule(selectedModule);
            }
          }}
          className="FW-module-selector"
        >
          {adminStore.modules.map((mod) => (
            <option key={mod.charge_id} value={mod.charge_id}>
              {mod.charge_id}
            </option>
          ))}
        </select>
        <button
          onClick={onStopPolling}
          className="FW-stop-button"
        >
          Остановить
        </button>
      </div>
    </div>
  );
});

export default FirmwareSelector;
